import React from "react"
import { Auth0Provider } from "@auth0/auth0-react"
import { AuthProvider } from "./src/context/auth"
import PrivateRoute from "./src/components/PrivateRoute"
import "./src/components/Layout/layout.css"

export const wrapRootElement = ({ element }) => (
  <Auth0Provider
    domain={process.env.GATSBY_AUTH0_DOMAIN}
    clientId={process.env.GATSBY_AUTH0_CLIENT_ID}
    redirectUri={`${process.env.GATSBY_ORIGIN_URL}/callback`}
  >
    <AuthProvider>{element}</AuthProvider>
  </Auth0Provider>
)

export const wrapPageElement = ({ element, props }) => {
  if (props.pageContext && props.pageContext.isPrivate) {
    return <PrivateRoute {...props}>{element}</PrivateRoute>
  }

  return element
}
